export default "__VITE_ASSET__Bwz2S4a7__"